export const Select = {
  defaultProps: {
    focusBorderColor: 'brand.secondary',
  },
}
